import { lazyLoadView } from '@utils/LazyLoad'

// Página de showcase do Design System (interna AAWZ). Só usuários internos
// (only_aawz: true) — o router guard redireciona não-internos para 404.
export default [
  {
    path: '/design-system',
    name: 'design-system',
    meta: {
      permission: ['profissional'],
      only_aawz: true,
    },
    component: () =>
      lazyLoadView(import('@modules/design-system/view/showcase.vue')),
  },
]
